import React from 'react';
import { colourways, brand } from '../mock/data';

const Card = ({ name, color, src }) => (
  <figure className="reveal group h-full flex flex-col rounded-[10px] border border-[var(--line)] overflow-hidden bg-white">
    <div
      className="relative flex items-center justify-center aspect-square overflow-hidden"
      style={{ background: `linear-gradient(180deg, ${color}14, #ffffff 82%)` }}
    >
      <img
        src={src}
        alt={`${name} Lotus Tote`}
        className="h-full w-full object-contain p-3 transition-transform duration-700 ease-out group-hover:scale-105"
      />
    </div>
    <figcaption className="mt-auto flex items-center justify-between px-5 py-4 border-t border-[var(--line)]">
      <span className="flex items-center gap-2.5 text-[14px] uppercase tracking-[0.14em] text-[var(--ink)]">
        <span className="h-2.5 w-2.5 rounded-full" style={{ background: color }} />
        {name}
      </span>
      <span className="text-[11px] uppercase tracking-[0.14em] text-[var(--muted)]">20 pieces</span>
    </figcaption>
  </figure>
);

const Colourways = () => (
  <section id="colours" className="relative bg-white py-24 md:py-32">
    <div className="max-frame container-px">
      <div className="text-center max-w-[760px] mx-auto">
        <p className="reveal text-[11px] uppercase tracking-kicker text-[var(--muted)]">The collection</p>
        <h2 className="reveal mt-5 font-display uppercase font-tight text-[clamp(2.2rem,5vw,4.2rem)] leading-[0.95]">
          Four colors, <span className="text-[var(--accent)]">one icon</span>
        </h2>
        <p className="reveal mt-5 text-[var(--muted)] text-lg leading-relaxed">
          Each Lotus Tote carries the Purple Lotus emblem on heavyweight white canvas, trimmed in its
          own signature shade. Only 20 made in each color.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-7 auto-rows-fr">
        {colourways.map((c) => (
          <Card key={c.name} {...c} />
        ))}
      </div>
    </div>
  </section>
);

export default Colourways;
